import React, { useState, useEffect } from 'react'
import BlogSection from './BlogSection';
import shortid from "shortid";
import Helper from './Helper';
import { useSelector } from 'react-redux';
import useStateRef from 'react-usestateref';
import RecentBlogsPlugin from './RecentBlogsPlugin';
import SharePlugin from './SharePlugin'

function BlogContainer({ containerObject, templateName, contentId, dataZone }) {

  const blogPageTheme = useSelector(state => state.GetBlogPageThemeReducer)
  const theme = blogPageTheme?.blogTheme

  const [widthState, setWidthState] = useState(0)
  const [screenWidth, setScreenWidth] = useState(0)
  const [readMinutes, setReadMinutes] = useState(0)
  const [showTableOfContents, setShowTableOfContents, showTableOfContentsRef] = useStateRef(false)
  const [listOfRecentBlogs, setListOfRecentBlogs] = useState(containerObject?.listOfRecentBlogs);

  
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    setScreenWidth(document.body.getBoundingClientRect().height)
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    var noOfWords = 0;
    var arrayOfWords = [];
    if (containerObject.attributes.containerTitle) {
      arrayOfWords = containerObject.attributes.containerTitle.trim().split(/\s+/);
      noOfWords += arrayOfWords.length;
    }
    if (containerObject.attributes.teaser) {
      arrayOfWords = containerObject.attributes.teaser.trim().split(/\s+/);
      noOfWords += arrayOfWords.length;
    }

    containerObject.sections && containerObject.sections.map((section, index) => {
      if (section.attributes.title) {
        setShowTableOfContents(true)
        arrayOfWords = containerObject.attributes.teaser.trim().split(/\s+/);
        noOfWords += arrayOfWords.length;
      }
      if (section.body) {
        const htmlString = section.body;
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlString;
        const textContent = tempElement.textContent || tempElement.innerText;
        arrayOfWords = textContent.trim().split(/\s+/);
        noOfWords += arrayOfWords.length;
      }
    })
    setReadMinutes(Math.floor(noOfWords / 200));

  }, [containerObject])


  useEffect(() => {
    if (containerObject?.listOfRecentBlogs) {
      setListOfRecentBlogs(containerObject.listOfRecentBlogs)
    }
  }, [containerObject?.listOfRecentBlogs])

  const blogStyle = {
    backgroundColor: theme.blogBackgroundColor
  }

  const contentStyle = {
    backgroundColor: theme.contentBackgroundColor
  }
  
  const containerTitleStyle = {
    fontSize: theme.titleFontSize ? theme.titleFontSize : "",
    color: theme.titleFontColor ? theme.titleFontColor : "",
    justifyContent: containerObject.attributes.titleLayout ? containerObject.attributes.titleLayout : "",
    backgroundColor: theme.titleBackgroundColor ? theme.titleBackgroundColor : "",
    fontFamily: theme.titleFontFamily ? theme.titleFontFamily : "",
  }

  const teaserStyle = {
    fontSize: theme.teaserFontSize ? theme.teaserFontSize : "",
    color: theme.teaserFontColor ? theme.teaserFontColor : "",
    justifyContent: theme.teaserLayout ? theme.teaserLayout : "",
    backgroundColor: theme.teaserBackgroundColor ? theme.teaserBackgroundColor : "",
    fontFamily: theme.teaserFontFamily ? theme.teaserFontFamily : "",
  }
  
  const scrollToSection = (id) => {
    var section = document.getElementById(id)
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' })
    }
  }
  const handleScroll = () => {
    var scrollPercentage = (-(document.body.getBoundingClientRect().top) / (document.body.getBoundingClientRect().height - document.documentElement.clientHeight)) * 100;
    setWidthState(scrollPercentage);
  }
  
  return (
    <div data-cont-id={containerObject.contentId}
      data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} style={blogStyle}
      className={"vast-plugin-content justify-content-around row mx-0 col-md-12 my-1"} id={containerObject.attributes.ArticleId ? containerObject.attributes.ArticleId : ""}>

      {theme.progressBar == 'true' &&
        <div class="progress" style={{ position: 'sticky', top: '0', background: 'none', height: '5px', marginRight: '50px' }}>
          <div class="progress-bar" role="progressbar" style={{ width: `${widthState}%`, color: 'rgb(53, 100, 154)' }} aria-valuenow={widthState} aria-valuemin="0" aria-valuemax={screenWidth}></div>
        </div>
      }

      {theme.tableOfContents == 'true' && showTableOfContentsRef?.current &&
        <div className='col-3' style={{ marginTop: '150px' }}>
          <hr style={{ color: `${theme.titleFontColor}`, borderTopWidth: '10px' }} />
          <section>
            <div >
              <h3 style={{ color: `${theme.titleFontColor}` }}>Table of contents</h3>
              <ul>
                {containerObject.sections && containerObject.sections.map((content, index) => {
                  if (content?.attributes?.title) {
                    return (
                      <li style={{ margin: '8px', fontSize: '13px' }}>
                        <button onClick={() => scrollToSection(Helper.labelMerger(content.attributes.title))} style={{ background: 'none', color: '#0369a1', textAlign: 'left' }}>{content.attributes.title}</button>
                      </li>
                    )
                  }
                })}
              </ul>
            </div>
            <p>
            </p>
          </section>
          <hr style={{ color: `${theme.titleFontColor}`, borderTopWidth: '10px' }} />
        </div>
      }

      <div className={`mx-0 my-2 ${theme?.blogLayout}`} style={contentStyle}>
        {containerObject?.attributes?.containerTitle ?
          <h1 className={` ${'d-flex my-2'}`} style={containerTitleStyle}>{containerObject.attributes.containerTitle}</h1> : ""
        }
        {containerObject?.attributes?.teaser ?
          <h4 className={` ${'d-flex'}`} style={teaserStyle}>{containerObject.attributes.teaser}</h4> : ""
        }

        <div className="row mb-3" style={{ fontSize: '15px', color: `${theme.titleFontColor}` }}>
          <div className="col-md-6 my-2 d-flex justify-content-start">
            <i className="bi bi-person-circle"></i>
            <a href="#" target='_blank' >
              <span style={{ marginLeft: '10px' }}>{containerObject.userName ? containerObject.userName : ''}&nbsp;</span>
            </a>
            <p>| {readMinutes} Minutes Read</p>
          </div>
          <div className="col-md-6 my-2 d-flex justify-content-end">
            <i className="bi bi-clock"></i>
            <span style={{ marginLeft: '10px' }}>{containerObject.publishDate ? Helper.blogDateFormatter(containerObject.publishDate) : ""}</span>
          </div>
        </div>

        {containerObject.blogImage ?
          <img fetchpriority="high" src={`${containerObject.blogImage ? containerObject.blogImage : ""}`} className={`img-fluid`} style={{ width: '100%' }} /> : ""
        }
        {containerObject.sections && containerObject.sections.map((content, index) => {
          return <BlogSection articleIndex={index} key={shortid.generate()} blogSectionObj={content} theme={theme}></BlogSection>
        })}
      </div>

      <RecentBlogsPlugin listOfRecentBlogs={listOfRecentBlogs}/>
      <SharePlugin />
      

    </div>

  )
}

export default BlogContainer
